module.exports = __webpack_public_path__ + "img/icon5.c52d2155.png";